exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plr-20[data-v-294622e0]{margin-left:-20px;margin-right:-20px}tr[data-v-294622e0]:last-child{border-bottom:1px solid #dee2e6}tbody.fp-body td[data-v-294622e0]{vertical-align:middle}select[data-v-294622e0]{width:216px}", ""]);

// exports
